import React from "react";

const Roverrangers = () => {
  return (
    <div>
      <div className="main-body">
        <div>
          <section className="in-banner">
            <div className="inheading">
              <h1>Rover Rangers</h1>
            </div>
          </section>
          <div className="breed-crum-div-wrap">
            <div className="breed-crum-div">
              <ol className="breadcrumb">
                <li>
                  <a href="/" className="external none">
                    Home
                  </a>
                  <span> | </span>
                </li>
                <li>
                  <a href="/events" className="external none">
                    EVENTS
                  </a>
                  <span> | </span>
                </li>
                <li>
                  <a href="/events/rover-rangers" className="external none">
                    ROVER-RANGERS
                  </a>
                </li>
              </ol>
            </div>
          </div>
          <div className="contentarea">
            <div className="sub-contentarea">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-md-4">
                  <img
                    decoding="async"
                    src="https://campus.acetians.in/custom/images/rover1.png"
                    alt
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="col-md-8" style={{ margin: "auto" }}>
                  <div>
                    <div className>
                      <p>
                        <b>Introduction: </b>Rovering / Rangering is a way of
                        life. It’s the senior wing of Scout and Guiding.
                        Rovering / Rangering was started by founder of the Scout
                        Movement Lord Baden Powell in 1918. Any regular student
                        of College/ University between the age group of 15 to 25
                        years can be enlisted as Rover (Boy) / Ranger (Girl). A
                        unit consists of 24 Rovers called Rover Crew and 24
                        Rangers called Ranger Team. Rovering /Rangering is a
                        uniformed activity.{" "}
                      </p>
                      <br />
                      <p>
                        <b>Membership: </b>A Rover crew is run under the
                        leadership of Rover Scout Leader and Ranger team is run
                        under the leadership of Ranger Leader registered in
                        college. Any regular male student can join Rover crew
                        and female student can join Ranger Team. If member is
                        exceeding 24 in a unit, a new (Rover Crew/Ranger Team)
                        unit can be formed
                      </p>
                      <br />
                      <p>
                        <b>Rover/Ranger activities: </b>Crew/Team meet to enjoy
                        social activities, fun, adventure, and
                        once-in-a-life-time experiences – with a highly flexible
                        program to suit every individual. A true Rover/Ranger
                        strives to serve the community, make life-long friends
                        and seize every available opportunity.
                        Rovering/Rangering provide various types of training
                        related to the personality development like- National
                        Integration Camps, Skill Development Programmes,
                        Government Initiatives, Swachh Bharat, Ek Bharat
                        Shreshtha Bharat, Disaster Management, Fire Fighting,
                        Messengers of Peace.
                      </p>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row col-md-12  d-flex">
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger2.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger2.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger3.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger3.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger4.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger4.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger5.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger5.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger6.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger6.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger7.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger7.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger8.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger8.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
              <div className="col-md-3">
                <div style={{ padding: 10 }}>
                  <a
                    href="https://campus.acetians.in/custom/images/roverranger9.jpeg"
                    target="_blank"
                  >
                    <img
                      src="https://campus.acetians.in/custom/images/roverranger9.jpeg"
                      style={{ width: "100%", maxHeight: 300 }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Roverrangers;
